import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${Colors.bgLight};
`;

export const Card = styled.div`
  background-color: ${Colors.commons.white};
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px 40px;
  text-align: center;
`;

export const Title = styled.h2`
  color: ${Colors.commons.darkGray};
  font-size: 20px;
  margin-bottom: 12px;
`;

export const Number = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: ${Colors.primary};
`;
